import { render, staticRenderFns } from "./MailLogList.vue?vue&type=template&id=c4546262&scoped=true&"
import script from "./MailLogList.vue?vue&type=script&lang=js&"
export * from "./MailLogList.vue?vue&type=script&lang=js&"
import style0 from "./MailLogList.vue?vue&type=style&index=0&id=c4546262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4546262",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VContainer,VRow})
